import { Directive, HostListener } from '@angular/core';
import { TOAST_EVENT } from '@/app/core/toasts/broadcast-toast';

import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[rdoToasts]',
  standalone: true,
})
export class ToastsDirective {
  constructor(public toastr: ToastrService) {}

  // Listen for the custom event globally on the window
  @HostListener(`window:${TOAST_EVENT.SUCCESS}`, ['$event'])
  onSuccessEvent(event: CustomEvent<{ message: string }>) {
    console.log('Received event data in Angular:', event.detail.message);
    this.handleEvent(event);
  }

  // Listen for the custom event globally on the window
  @HostListener(`window:${TOAST_EVENT.ERROR}`, ['$event'])
  onErrorEvent(event: CustomEvent<{ message: string }>) {
    console.log('Received event data in Angular:', event.detail.message);
    this.handleEvent(event);
  }

  private handleEvent(event: CustomEvent) {
    console.log('toasts.component.handleEvent  received event', event);
    switch (event.type) {
      case TOAST_EVENT.SUCCESS:
        this.toastr.success(event.detail.title, event.detail.message);
        break;
      case TOAST_EVENT.ERROR:
        this.toastr.error(event.detail.title, event.detail.message);
        break;
    }
  }
}
